"use client";
import { useContext } from "react";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import { useCreateSwagContext } from "@contexts/create-swag-context";
import classNames from "classnames";
import Multimedia from "@sharedComponents/multimedia";

import {
  getStoreTopBanner,
  getIsLockerShop,
  getStoreMobileTopBanner,
} from "@store/selectors/store";

import styles from "./main.module.scss";

const DEFAULT_HEIGHT = 455;
const DEFAULT_LOCKER_HEIGHT = 256;

const HeroImage = ({ editingAllowed, data = {}, children, topBannerRequired = false, store }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { isSwagCreationShopFlow } = useCreateSwagContext();

  const topBanner = getStoreTopBanner({ store });
  const mobileTopBanner = getStoreMobileTopBanner({ store });
  const isLockerShop = getIsLockerShop({ store });

  const { imageOne, imageTwo } = data;

  const height = isLockerShop ? DEFAULT_LOCKER_HEIGHT : DEFAULT_HEIGHT;

  const topBannerImg = (isMobileDevice && mobileTopBanner) || topBanner || imageOne;
  const imgSrc = topBannerRequired ? topBannerImg : (isMobileDevice && imageTwo) || imageOne;

  return (
    <article
      className={classNames(styles.heroImageContainer, {
        [styles.swagCreationShopFlow]: isSwagCreationShopFlow,
        [styles.topBannerRequired]: topBannerRequired,
      })}
    >
      <Multimedia
        type="image"
        src={imgSrc}
        className={styles.bannerImage}
        height={height}
        width={2160}
        key={imgSrc}
        fetchPriority="high"
      />
      {editingAllowed && children}
    </article>
  );
};

export default HeroImage;
